import { Component, EventEmitter, Input, Output, OnInit, ElementRef, AfterViewInit } from "@angular/core";

@Component({
  selector: 'upsell-sticky-bar-v2',
  templateUrl: 'upsell-sticky-bar-v2.html',
  styleUrls: ['upsell-sticky-bar-v2.scss']
})
export class UpsellStickyBarV2 implements OnInit, AfterViewInit {
  @Input() currency: string = 'USD';
  @Input() productBrand: string;
  @Input() productName: string;
  @Input() productQuantity: any;
  @Input() productUnitType: string;
  @Input() productYourPrice: number;
  @Input() productImage: string;
  @Output() itemAdded = new EventEmitter<boolean>();

  //Provide external method to navigate to next page over funnel
  @Output() eventEmitter: EventEmitter<boolean> = new EventEmitter();

  buttonValue: boolean = false;
  
  constructor(private elementRef: ElementRef) {}
  
  ngOnInit() {
    // Component initialized
  }
  
  ngAfterViewInit() {
    // Wait for view to render, then apply padding
    setTimeout(() => {
      const height = this.elementRef.nativeElement.offsetHeight;
      const footer = document.querySelector('.upsell-footer') as HTMLElement;
      
      if (footer && height > 0) {
        footer.style.paddingBottom = `${height}px`;
      }
    }, 100);
  }

  addToCart() {
    this.itemAdded.emit(true);
  }
  
  nextPage(buttonValue: boolean) {
    this.buttonValue = buttonValue ? true : false;
    this.eventEmitter.emit(this.buttonValue);
  }
}